import { render, staticRenderFns } from "./OrganizationParent.vue?vue&type=template&id=b5b15942"
import script from "./OrganizationParent.vue?vue&type=script&lang=js"
export * from "./OrganizationParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports